import { api, handleError } from "./baseApi";

export async function getAllAdmins(filters = {}) {
  try {
    const { data } = await api.get("/admin", {
      params: {
        page_no: filters.page_no,
        limit: filters.limit,
        search_key: filters.search_key || "",
        search_role: filters.search_role || "",
      },
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function addAdmin(admin) {
  try {
    const { data } = await api.post("/admin", admin);
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function deleteAdmin(adminID) {
  try {
    const { data } = await api.delete(`/admin/${adminID}`);
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function updateAdmin(adminID, updates) {
  try {
    const { data } = await api.put(`/admin/${adminID}`, updates);
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function getAdminById(adminID) {
  try {
    const { data } = await api.get(`/admin/${adminID}`);
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function getHomeData(filters) {
  try {
    const { data } = await api.get(`/dashboard`, {
      params: {
        ...filters,
      },
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}
